import { useState } from "react";
import { useNavigate } from "react-router-dom";

const Menu = (props) => {
  const navigate = useNavigate();
  const crmUser = JSON.parse(localStorage.getItem('crmUser'));

  // Check if current page is a support sub-page
  const isSupportActive = props.active === 'support' ||
    props.active === 'support-tags' ||
    props.active === 'support-queue' ||
    props.active === 'support-notif' ||
    props.active === 'support-report';

  const [isSupportOpen, setIsSupportOpen] = useState(isSupportActive);

  const toggleSupport = (e) => {
    e.preventDefault();
    setIsSupportOpen(!isSupportOpen);
  };

  const isEventActive = props.active === 'event' ||
    props.active === 'event-ai-setting' ||
    props.active === 'event-contact';

  const [isEventOpen, setIsEventOpen] = useState(isEventActive);

  const toggleEvent = (e) => {
    e.preventDefault();
    setIsEventOpen(!isEventOpen);
  };

  return (
    <ul className="ps-2 py-2 d-md-block d-none sidebar mb-0" id="side-bar">
      {(crmUser.user_level === 'Admin' || crmUser.user_level === 'View') && (
        <>
          <li className={props.active === 'dashboard' ? 'active' : ''}><a href="/dashboard"><i className="bi bi-house-door me-2" /> Dashboard</a></li>
          <li className={props.active === 'report' ? 'active' : ''}><a href="/report"><i className="bi bi-graph-up-arrow me-2" /> Report</a></li>
          <li className={props.active === 'client' ? 'active' : ''}><a href="/client"><i className="bi bi-building me-2" /> Clients</a></li>
          <li className={props.active === 'lead' ? 'active' : ''}><a href="/lead"><i className="bi bi-crosshair me-2" /> Leads</a></li>
          <li className={props.active === 'opportunity' ? 'active' : ''}><a href="/opportunity"><i className="bi bi-gem me-2" /> Opportunities</a></li>
          <li className={props.active === 'quotation' ? 'active' : ''}><a href="/quotation"><i className="bi bi-file-earmark-text me-2" /> Quotations</a></li>
          <li className={props.active === 'salesorder' ? 'active' : ''}><a href="/salesorder"><i className="bi bi-cart-check me-2" /> Sales Orders</a></li>
          <li className={props.active === 'invoicerequest' ? 'active' : ''}><a href="/invoicerequest"><i className="bi bi-receipt-cutoff me-2" /> Invoice Requests</a></li>
          <li className={props.active === 'product' ? 'active' : ''}><a href="/product"><i className="bi bi-box-seam me-2" /> Products</a></li>
          <li className={props.active === 'user' ? 'active' : ''}><a href="/user"><i className="bi bi-people me-2" /> Users</a></li>
          <li className={props.active === 'attainment' ? 'active' : ''}><a href="/attainment"><i className="bi bi-cash me-2" /> Attainments</a></li>
          <li className={props.active === 'project-tracker' ? 'active' : ''}><a target="_blank" rel="noopener noreferrer" href="https://cuancuan.point-star.com/pt-ui"><i className="bi bi-kanban me-2" /> Project Tracker</a></li>
        </>
      )}
      {crmUser.user_department !== 'Support' && crmUser.user_level !== 'Admin' && crmUser.user_level !== 'View' && (
        <>
          {crmUser.user_department === 'Marketing' && (<>
            {crmUser.user_role_division === "Manager" && (
              <li className={props.active === 'report' ? 'active' : ''}><a href="/report"><i className="bi bi-graph-up-arrow me-2" /> Report</a></li>
            )}
            <li className={props.active === 'client' ? 'active' : ''}><a href="/client"><i className="bi bi-building me-2" /> Clients</a></li>
            {crmUser.user_position.toLowerCase().trim() !== "event executive" && (
              <>
                <li className={props.active === 'lead' ? 'active' : ''}><a href="/lead"><i className="bi bi-crosshair me-2" /> Leads</a></li>
                <li className={props.active === 'opportunity' ? 'active' : ''}><a href="/opportunity"><i className="bi bi-gem me-2" /> Opportunities</a></li>
              </>
            )}
          </>
          )}
          {(crmUser.user_department !== 'Marketing' && crmUser.user_department !== 'Sales Admin') && (
            <>
              <li className={props.active === 'dashboard' ? 'active' : ''}><a href="/dashboard"><i className="bi bi-house-door me-2" /> Dashboard</a></li>
              <li className={props.active === 'report' ? 'active' : ''}><a href="/report"><i className="bi bi-graph-up-arrow me-2" /> Report</a></li>
              <li className={props.active === 'lead' ? 'active' : ''}><a href="/lead"><i className="bi bi-crosshair me-2" /> Leads</a></li>
              <li className={props.active === 'client' ? 'active' : ''}><a href="/client"><i className="bi bi-building me-2" /> Clients</a></li>
              <li className={props.active === 'opportunity' ? 'active' : ''}><a href="/opportunity"><i className="bi bi-gem me-2" /> Opportunities</a></li>
              <li className={props.active === 'quotation' ? 'active' : ''}><a href="/quotation"><i className="bi bi-file-earmark-text me-2" /> Quotations</a></li>
              <li className={props.active === 'salesorder' ? 'active' : ''}><a href="/salesorder"><i className="bi bi-cart-check me-2" /> Sales Orders</a></li>
              <li className={props.active === 'invoicerequest' ? 'active' : ''}><a href="/invoicerequest"><i className="bi bi-receipt-cutoff me-2" /> Invoice Requests</a></li>
              <li className={props.active === 'product' ? 'active' : ''}><a href="/product"><i className="bi bi-box-seam me-2" /> Products</a></li>
              <li className={props.active === 'attainment' ? 'active' : ''}><a href="/attainment"><i className="bi bi-cash me-2" /> Attainments</a></li>
              <li className={props.active === 'project-tracker' ? 'active' : ''}><a target="_blank" rel="noreferrer" href='https://cuancuan.point-star.com/pt-ui'><i className="bi bi-kanban me-2" /> Project Tracker</a></li>
            </>
          )}
          {(crmUser.user_department === 'Sales Admin') && (
            <>
              <li className={props.active === 'dashboard' ? 'active' : ''}><a href="/dashboard"><i className="bi bi-house-door me-2" /> Dashboard</a></li>
              <li className={props.active === 'report' ? 'active' : ''}><a href="/report"><i className="bi bi-graph-up-arrow me-2" /> Report</a></li>
              <li className={props.active === 'client' ? 'active' : ''}><a href="/client"><i className="bi bi-building me-2" /> Clients</a></li>
              <li className={props.active === 'quotation' ? 'active' : ''}><a href="/quotation"><i className="bi bi-file-earmark-text me-2" /> Quotations</a></li>
              <li className={props.active === 'salesorder' ? 'active' : ''}><a href="/salesorder"><i className="bi bi-cart-check me-2" /> Sales Orders</a></li>
              <li className={props.active === 'invoicerequest' ? 'active' : ''}><a href="/invoicerequest"><i className="bi bi-receipt-cutoff me-2" /> Invoice Requests</a></li>
            </>
          )}

        </>
      )}
      {(crmUser.user_department === 'Support' || crmUser.user_level === 'Admin' || crmUser.user_level === 'View') && (
        <>
          <li className={isSupportActive ? 'active' : ''}>
            <button type="button" onClick={toggleSupport} className="d-flex justify-content-between align-items-center btn btn-link">
              <span><i className="bi bi-person-workspace me-2" /> Support</span>
              <i className={`bi ${isSupportOpen ? 'bi-chevron-down' : 'bi-chevron-right'} small me-2`}></i>
            </button>
          </li>

          {isSupportOpen && (
            <div className="bg-light rounded mx-2 mb-2 overflow-hidden" style={{ transition: 'all 0.3s' }}>
              <ul className="list-unstyled mb-0">
                <li>
                  <div onClick={() => navigate('/support-report')} className={`d-block py-2 px-4 text-decoration-none ${props.active === 'support-report' ? 'text-warning fw-bold' : 'text-dark'}`} style={{ fontSize: '0.9rem', cursor: 'pointer' }}>
                    <i className="bi bi-clipboard-data me-2"></i> Report
                  </div>
                </li>
                <li>
                  <div onClick={() => navigate('/ticket')} className={`d-block py-2 px-4 text-decoration-none ${props.active === 'support' ? 'text-warning fw-bold' : 'text-dark'}`} style={{ fontSize: '0.9rem', cursor: 'pointer' }}>
                    <i className="bi bi-ticket-perforated me-2"></i> Ticket
                  </div>
                </li>
                <li>
                  <button type="button" onClick={() => navigate('/tags')} className={`d-block py-2 px-4 text-decoration-none btn btn-link ${props.active === 'support-tags' ? 'text-warning fw-bold' : 'text-dark'}`} style={{ fontSize: '0.9rem', cursor: 'pointer' }}>
                    <i className="bi bi-tags me-2"></i> Tags
                  </button>
                </li>
                <li>
                  <button type="button" onClick={() => navigate('/queue')} className={`d-block py-2 px-4 text-decoration-none btn btn-link ${props.active === 'support-queue' ? 'text-warning fw-bold' : 'text-dark'}`} style={{ fontSize: '0.9rem', cursor: 'pointer' }}>
                    <i className="bi bi-list-ol me-2"></i> Queue
                  </button>
                </li>
                <li>
                  <button type="button" onClick={() => navigate('/notif-email')} className={`d-block py-2 px-4 text-decoration-none btn btn-link ${props.active === 'support-notif' ? 'text-warning fw-bold' : 'text-dark'}`} style={{ fontSize: '0.9rem', cursor: 'pointer' }}>
                    <i className="bi bi-envelope me-2"></i> Notif Email
                  </button>
                </li>
              </ul>
            </div>
          )}
        </>
      )}

      {((crmUser.user_department === 'Marketing' && (crmUser.user_position.toLowerCase().trim() === "event executive" || crmUser.user_role_division === "Manager")) || crmUser.user_department === "Sales" || crmUser.user_level === 'Admin' || crmUser.user_level === 'View') && (
        <>
          <li className={isEventActive ? 'active' : ''}>
            <button type="button" onClick={toggleEvent} className="d-flex justify-content-between align-items-center btn btn-link">
              <span><i className="bi bi-calendar-event me-2" /> Event</span>
              <i className={`bi ${isEventOpen ? 'bi-chevron-down' : 'bi-chevron-right'} small me-2`}></i>
            </button>
          </li>

          {isEventOpen && (
            <div className="bg-light rounded mx-2 mb-2 overflow-hidden" style={{ transition: 'all 0.3s' }}>
              <ul className="list-unstyled mb-0">
                {crmUser.user_department !== 'Sales' && (
                  <>
                    <li>
                      <button type="button" onClick={() => navigate('/event/ai-setting')} className={`d-block py-2 px-4 text-decoration-none btn btn-link ${props.active === 'event-ai-setting' ? 'text-warning fw-bold' : 'text-dark'}`} style={{ fontSize: '0.9rem', cursor: 'pointer' }}>
                        <i className="bi bi-gear me-2"></i> AI Setting
                      </button>
                    </li>
                    <li>
                      <button type="button" onClick={() => navigate('/event/contact')} className={`d-block py-2 px-4 text-decoration-none btn btn-link ${props.active === 'event-contact' ? 'text-warning fw-bold' : 'text-dark'}`} style={{ fontSize: '0.9rem', cursor: 'pointer' }}>
                        <i className="bi bi-person-lines-fill me-2"></i> Contact
                      </button>
                    </li>
                  </>
                )}
                <li>
                  <button type="button" onClick={() => navigate('/event')} className={`d-block py-2 px-4 text-decoration-none btn btn-link ${props.active === 'event' ? 'text-warning fw-bold' : 'text-dark'}`} style={{ fontSize: '0.9rem', cursor: 'pointer' }}>
                    <i className="bi bi-calendar-check me-2"></i> Event
                  </button>
                </li>
              </ul>
            </div>
          )}
        </>
      )}
      <li><a className="text-danger" href="/logout"><i className="bi bi-door-open me-2" /> Logout</a></li>
    </ul>
  );
};

export default Menu;
